import { useForm } from "react-hook-form";
import {useAuth} from "../../contexts/auth/useAuth";
import { useEffect, useState } from "react";
import {  useNavigate } from "react-router";
import { FloatingInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";

interface loginFormData{
    user:string;
    password:string;
    auth?:string;
}

function LoginForm({state}:{state?:LocationState}) {
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors },
    } = useForm({
        defaultValues:{user:'', password:''} as loginFormData,
        mode:'onBlur',
    });
    const [submited, setSubmited]=useState(false);
    const [role,setRole]=useState('UV');
    const {login,isLoading,isAuthenticated } = useAuth();
    const nav = useNavigate();
    const {translate}=useTrads();
    console.log(state);
    const  onSubmit = async (data: loginFormData) => {
        const usr=await login(data.user, data.password);
        if(usr){
            setRole(usr.rangacces);
        }else{
            setError("auth",{type:"auth",message: translate('error_login_password')})
        }
        setSubmited(true);
    };

    useEffect(() => {
        if(submited && isAuthenticated){
            if(state?.from && state.role !=role){
               void nav(state.from.pathname);
            }else{
                if(role=='UN'){
                    void nav("/profil/edit");
                }else{
                    void nav("/");
                }
                
            }

        }
    },[isAuthenticated,submited,nav,role,state?.from,state?.role]);

    return (
        <form className="App row" onSubmit={(event) => void handleSubmit(onSubmit)(event)}>
            <div className="col-5  mb-3">

                <FloatingInputBootStrap
                    type="text"
                    name="user"
                    label={translate("login_form_username")}
                    registerOutput= {register("user", { 
                            required: translate('form_user_required')
                        })
                    }
                    errors={errors}
                    rest={{"autoComplete" : "username"}}
                />
            </div>
            <div className="col-5  mb-3">

                <FloatingInputBootStrap
                    type="password"
                    name="password"
                    label={translate("login_form_password")}
                    registerOutput= 
                    {register("password", 
                        { 
                            required: translate('form_password_required') }
                        )
                    }
                    errors={errors}
                    rest={{"autoComplete" : "current-password"}}
                />
            </div>
            <div className="col-2  mb-3">
                <button type="submit" className="form-control" >
                    {translate("login_form_submit")}
                </button>
            </div>
            <div className="col-12  mb-3">
                {errors.auth && <span className='text-danger'> {translate(errors.auth.message)} </span>}
                {isLoading?
                (<div className="spinner-border" role="status">
                    <span className="visually-hidden">{translate('page_loading')}</span>
                </div>)
                :null}
            </div>
        </form>
    );
}
export default LoginForm;

